import type { CSSProperties } from 'react';
import Book from './Book';
import type { BookData } from '@/mocks/books';

interface BookMarqueeProps {
  books: BookData[];
  speed?: number;
  tilt?: number;
  /**
   * How many books to display in total across the loop.
   * Will be rounded to the nearest even number so the
   * seamless 0 → -50% animation stays perfect.
   * Default is 88.
   */
  count?: number;
}

export default function BookMarquee({
  books,
  speed = 60,
  tilt = -7,
  count = 88,
}: BookMarqueeProps) {
  // Build a base sequence half the target length, then double it
  // so the marquee can translate by -50% and loop seamlessly.
  const half = Math.max(books.length, Math.floor(count / 2));
  const base: BookData[] = Array.from({ length: half }, (_, i) => books[i % books.length]);
  const repeated = [...base, ...base];
  const total = repeated.length;

  return (
    <div
      className="marquee-mask"
      style={{ '--marquee-tilt': `${tilt}deg` } as CSSProperties}
    >
      <div className="marquee-fade">
        <div
          className="marquee-track"
          style={{ '--marquee-speed': `${speed}s` } as CSSProperties}
        >
          {repeated.map((book, i) => (
            <div key={i} className="book-wrap" style={{ zIndex: total - i }} data-product-shop>
              <Book book={book} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}